import { NavLink } from 'react-router-dom';
import clsx from 'clsx';

const TABS = [
  { to: '/issue-receipt', label: 'Issue vouchers', end: true },
  { to: '/issue-receipt/receipts', label: 'Receipt vouchers', end: true },
];

/** Switches between the issue list and the receipt list — a receipt is otherwise only reachable by first finding its issue. */
export function VoucherTabs() {
  return (
    <div className="inline-flex gap-1 self-start rounded-card border border-border bg-surface-2 p-1">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            clsx(
              'rounded-card px-3.5 py-1.5 text-sm font-medium transition-colors',
              isActive ? 'bg-surface text-content' : 'text-muted hover:text-content',
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}

export default VoucherTabs;
